import { useEffect } from "react";

// Shared data-loss protection: fire a callback the moment the tab is hidden,
// backgrounded, or unloaded. Assign the freshest closure to flushRef.current
// on every render — no stale state.
export function useFlushOnHide(flushRef) {
  useEffect(() => {
    const onVisibility = () => {
      if (document.visibilityState === "hidden") flushRef.current?.();
    };
    const onHide = () => flushRef.current?.();
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pagehide", onHide);
    window.addEventListener("beforeunload", onHide);
    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pagehide", onHide);
      window.removeEventListener("beforeunload", onHide);
    };
  }, [flushRef]);
}

// fetch with keepalive:true survives tab suspension / page unload — the key
// fix for "minimize the tab → recent edits never reach the server".
// Auth rides on the httpOnly session cookie (credentials: 'include').
export function keepaliveSave(url, body, method = "PUT") {
  try {
    fetch(url, {
      method,
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => { /* tab is dying — nothing we can do */ });
  } catch { /* ignore */ }
}
